var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoDataSearchIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.907 17.25L22.8694 21.2124L21.242 22.8984L17.25 18.907L18.907 17.25Z",
  fill: "#D9D1EF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.52344 11.4844C1.52344 5.98301 5.98301 1.52344 11.4844 1.52344C16.9857 1.52344 21.4453 5.98301 21.4453 11.4844C21.4453 16.9848 16.9867 21.4453 11.4844 21.4453C5.98301 21.4453 1.52344 16.9857 1.52344 11.4844Z",
  fill: "#C9B6FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45312 11.4844C4.45313 7.60137 7.60137 4.45312 11.4844 4.45312C15.3674 4.45312 18.5156 7.60137 18.5156 11.4844C18.5156 15.3674 15.3674 18.5156 11.4844 18.5156C7.60137 18.5156 4.45312 15.3674 4.45312 11.4844Z",
  fill: "#F0EBFD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.82864 8.16796L11.0719 9.41121C11.3007 9.64002 11.6717 9.64002 11.9005 9.41121L13.1438 8.16796C13.3726 7.93916 13.7436 7.93916 13.9724 8.16796L14.8008 8.99636C15.0296 9.22517 15.0296 9.59619 14.8008 9.825L13.5575 11.0682C13.3287 11.297 13.3287 11.6681 13.5575 11.8969L14.8008 13.1401C15.0296 13.3689 15.0296 13.7399 14.8008 13.9687L13.9724 14.7971C13.7436 15.026 13.3726 15.026 13.1438 14.7971L11.9005 13.5539C11.6717 13.3251 11.3007 13.3251 11.0719 13.5539L9.82864 14.7971C9.59983 15.026 9.22881 15.026 9 14.7971L8.17161 13.9687C7.9428 13.7399 7.9428 13.3689 8.17161 13.1401L9.41485 11.8969C9.64366 11.6681 9.64366 11.297 9.41485 11.0682L8.17161 9.825C7.9428 9.59619 7.9428 9.22517 8.17161 8.99636L9 8.16796C9.22881 7.93916 9.59983 7.93916 9.82864 8.16796Z",
  fill: "#A98AFF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8176 20.3319C23.0464 20.1031 23.4174 20.1031 23.6463 20.332L27.7894 24.4756C28.7052 25.3909 28.7052 26.8745 27.7894 27.7897C26.8742 28.7055 25.3906 28.7055 24.4753 27.7897L20.3318 23.6468C20.1029 23.4179 20.1029 23.0468 20.3319 22.818C20.8896 22.2607 20.4227 22.7275 22.4035 20.7467V20.7461L22.8176 20.3319Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-data-search-icon.ae5f197cc2a658ca1d249953e946b344.svg";